export default "__VITE_ASSET__af830e53__"